// payment-api.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { setting } from '../../../../setting';
import { UsblickCommonEnum } from 'app/pages/com.usblick.common/usblick-common-enum';

@Injectable({
  providedIn: 'root'
})
export class PaymentApiService {
  private apiUrl = setting.apiBookingUrl;

  constructor(private http: HttpClient) {}

    /**
   * Método compartido para TODAS las pasarelas
   */
  async savePaymetCreditsCards(payload: any): Promise<any> {
    try {
console.log(JSON.stringify(payload))
      const response = await fetch(`${this.apiUrl}paymentCreditCards/create`, {
        method: "POST",
        headers: this.getHeaders(),
        body: JSON.stringify(payload)
    });

    const data = await response.json();
    console.log("Backend response:", data);
      console.log('llegué a mandar la información a back', '✅ Respuesta backend:', response);
      return data;

    } catch (error: any) {
      console.error('❌ Error en createPayment:', error);
      throw error;
    }
  }

  /**
   * Método compartido para TODAS las pasarelas
   */
  async createPayment(payload: any): Promise<any> {
    try {
console.log(JSON.stringify(payload))
      const response = await fetch(`${this.apiUrl}paymentMasters/create`, {
        method: "POST",
        headers: this.getHeaders(),
        body: JSON.stringify(payload)
    });

    const data = await response.json();
    console.log("Backend response:", data);

      return data;

    } catch (error: any) {
      console.error('❌ Error en createPayment:', error);
      throw error;
    }
  }

  private getCookie(name : string){
      //console.log ("document.cookie", document.cookie);
      var nameEQ = encodeURIComponent(name) + UsblickCommonEnum.equalChar;
        var ca = document.cookie.split(UsblickCommonEnum.dotCommaChar);
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === UsblickCommonEnum.spaceChar)
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0)
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }


  private getHeaders() {
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.getCookie('auth_token')}`
    };
  }
}
